import { AllieIconProps } from '../../../components';

export const BellOutlineIcon: React.FC<AllieIconProps> = ({ className, ...props }) => (
  <svg
    {...props}
    className={`stroke-icon ${className}`}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      // eslint-disable-next-line max-len
      d="M6.23612 14.4999C6.70621 14.9148 7.3237 15.1666 8 15.1666C8.6763 15.1666 9.29379 14.9148 9.76388 14.4999M12 5.83325C12 4.77239 11.5786 3.75497 10.8284 3.00482C10.0783 2.25468 9.06087 1.83325 8 1.83325C6.93913 1.83325 5.92172 2.25468 5.17157 3.00482C4.42143 3.75497 4 4.77239 4 5.83325C4 7.89338 3.48031 9.30389 2.89978 10.2369C2.41009 11.0238 2.16524 11.4173 2.17422 11.5271C2.18416 11.6486 2.20991 11.695 2.30785 11.7676C2.39631 11.8333 2.79506 11.8333 3.59257 11.8333H12.4074C13.2049 11.8333 13.6037 11.8333 13.6921 11.7676C13.7901 11.695 13.8158 11.6486 13.8258 11.5271C13.8348 11.4173 13.5899 11.0238 13.1002 10.2369C12.5197 9.30389 12 7.89338 12 5.83325Z"
      stroke={props.allieColor ? `var(--allie-color-${props.allieColor})` : '#94969C'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
